import { Component, Input } from '@angular/core';
import { DataService } from '@/core/services/data.service';
import { PaginationRequest, PaginationResult } from '@/core/core.barrel';
import { HistoryFilter, ObjectHistoryFieldMetadata, ObjectHistoryModel, ObjectHistoryType } from '@/shared/models/shared';
import { toJson } from '@/shared/classes/utils';
import { SelectItem } from 'primeng/api';
import { map, Observable } from 'rxjs';
import { isEmpty } from 'lodash';

@Component({
    selector: 'ciee-object-history',
    templateUrl: './object-history.component.html',
    styleUrls: ['./object-history.component.scss'],
    standalone: false
})
export class ObjectHistoryComponent {
  @Input() id: number;
  @Input() type: ObjectHistoryType;
  @Input() fieldNames: Array<ObjectHistoryFieldMetadata>;

  historyUrl: string;
  lookupUrl: string;

  pageSize: number = 10;
  loading: boolean = true;
  paginator: PaginationRequest;
  filter: HistoryFilter = new HistoryFilter();
  dateRange: Date[] = [];
  maxDate: Date = new Date();
  columns: any[];

  data: ObjectHistoryModel[];
  totalCount: number = 1000;

  users: SelectItem[] = new Array<SelectItem>();
  fields: SelectItem[] = new Array<SelectItem>();

  constructor(private http: DataService) { }

  ngOnInit() {
    this.historyUrl = `/history/${this.type}/${this.id}`;
    this.lookupUrl = `/history/lookup/${this.type}/${this.id}`;

    this.getLookup('users').subscribe(res => this.users = res);
    this.getLookup('fields').subscribe(res => {
      this.fields = res.map(item => ({
        ...item,
        label: this.getFieldFriendlyName(item.label)
      }));
    });
  }

  load(event: PaginationRequest) {
    this.loading = true;
    this.paginator = event;

    var url = `${this.historyUrl}?${PaginationRequest.toQuery(event)}`;
    if (!isEmpty(this.filter)) url += `&${this.toQuery(this.filter)}`;

    this.http.get(url).subscribe((resp: PaginationResult<ObjectHistoryModel>) => {
      resp.data.forEach(element => {
        element.dataObject = toJson(element.data);
      });

      this.data = resp.data;
      this.totalCount = resp.totalCount;

      this.loading = false;
    });
  }

  onFilterChange() {
    this.load(this.paginator);
  }

   onClearFilters() {
    this.filter.users = null;    
    this.filter.fields = null;
    this.dateRange = null;
    this.onDateChange(this.dateRange);
    
  }
  onDateChange(value: Date[] | null) {
    if (value)
    {
      const [from, to] = value;
      this.filter.dateFrom = from;
      this.filter.dateTo = to;
    }
    else {
      this.filter.dateFrom = null;
      this.filter.dateTo = null;
    }

    this.onFilterChange();
  }

  getLookup(lookupType: string): Observable<SelectItem[]> {
    return this.http.get(`${this.lookupUrl}/${lookupType}`).pipe(map((resp: Array<any>) => {
      resp.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
      return resp;
    }));
  }
    
  getFieldFriendlyName(field: string) {
    var fieldName = this.fieldNames.filter(x => x.fieldName == field);
    return fieldName.length > 0 ? fieldName[0].displayName : field;
  }

  private toQuery(obj: Record<string, any>): string {
    if (!obj || Object.keys(obj).length === 0) return '';
  
    const queryParts: string[] = [];
  
    for (const [key, value] of Object.entries(obj)) {
      if (Array.isArray(value)) {
        value.forEach(v => {
          queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
        });
      }
      else if(value instanceof Date) {
        const formatted = value.toISOString().slice(0, 10);
        queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(formatted)}`);
      }
      else if (value !== undefined && value !== null) {
        queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
  
    return queryParts.join('&');
  }
}
